import React from 'react';
import PropTypes from "prop-types";

const GenerateButton = ({ type = 'button', ...props}) => {
  return (
    <button
      type={type}
      className="form-wizard-action btn btn-primary"
      {...props}
    >
      <i className="fas fa-check-circle fs-4 me-2"/>
      Generate
    </button>
  )
}

GenerateButton.propTypes  = {
  type: PropTypes.string,
}

export default GenerateButton